module.exports = __webpack_public_path__ + "img/icon-plus.51d5170e.svg";